import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import VueClipboard from 'vue-clipboard2'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

// axios.defaults.baseURL = 'http://localhost:9233/server/'
axios.defaults.baseURL = 'https://api.01shuati.cn/server/'
Vue.prototype.$http = axios
Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
